export default {
  en: {
    title: 'Search results for "{q}"',
    titleEmptySearch: 'Search Results',
    emptySearch: 'Nothing to search',
    noResults: 'No results have been found',
    errorOccured: 'Error occured',
  },
};
